import { render } from "./CarbonDioxideReport.vue?vue&type=template&id=3b54b6ac"
import script from "./CarbonDioxideReport.vue?vue&type=script&lang=js"
export * from "./CarbonDioxideReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__